import React, {useState, useRef} from 'react';
import {Col, Row} from "react-bootstrap";
import BootstrapTable from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import TableTopBar from "./top/TableTopBar";
import Pagination from "../common/Pagination";
import PopUp from "../popUp/PopUp";
import Swal from "sweetalert2";
import {getSysOperationLogWord, getSysReportAll, getSysReportWord} from "../../api/apiClient";
import Moment from "moment";
import OperationLogUpload from "../../pages/subPages/operationLogUpload";
import {exportExcel} from "../../common/exportExcel";
import {exportPdf} from "../../common/exportPdf";
import usePdf from "../../hook/usePdf";

const TableReport = ({
                       currentPage,
                       setCurrentPage,
                       listPageSize,
                       setListPageSize,
                       total,
                       tableList,
                       setIsSearch,
                       setTableList,
                       setTotal,
                       updateList,
                       searchParam,
                     }) => {

  // select ////////////////////////////////////
  const updatePageSize = (aSize) => {
    setIsSearch(true);
    setCurrentPage(1);
    setListPageSize(parseInt(aSize));
  };

  const tableRef = useRef(null);
  const [isExport, setIsExport] = useState(false);

  const onDownload = () => {
    exportExcel(tableRef, "일일운영일지_.xls")
  }

  const getAllList = () => {
    setIsExport(true);

    getSysReportAll(
        currentPage, listPageSize,
        Moment(searchParam.startDate).format('YYYY-MM-DD'),
        Moment(searchParam.endDate).format('YYYY-MM-DD'))
        .then((res) => {
              // console.log(res);
              if (res.data.data !== undefined) {
                setTableList(res.data.data.list);
                setTotal(res.data.data.total);
              }
            }
        );
  };

  const downloadExcelToTable = () => {
    getAllList();

    Swal.fire({
      title: `EXCEL 다운로드 하시겠습니까?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `확인`,
      cancelButtonText: '취소'
    }).then((result) => {
      if (result.isConfirmed) {
        onDownload();
      }
      setIsExport(false);

      updateList();
    })
  };

  const exportReport = () => {
    getAllList();

    Swal.fire({
      title: `PDF 다운로드 하시겠습니까?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `확인`,
      cancelButtonText: '취소'
    }).then((result) => {
      if (result.isConfirmed) {
        exportPdf(tableRef, '일일운영일지.pdf');
      }
      setIsExport(false);

      updateList();
    });
  };

  /* 팝업을 위한 state */
  const [openPopupReg, setPopupReg] = useState({isVisible: false, stdde: "0001-01-01", mode: 'post'});

  const closePopupReg = () => {
    setPopupReg({isVisible: false, stdde: "0001-01-01"});
    setIsSearch(true);
  };

  const regItem = (e = null) => {
    const auth = sessionStorage.getItem('CURRENT_AUTH');
    if (auth != 2) {
      Swal.fire('권한이 없습니다.');
    } else {
      setPopupReg({
        isVisible: true,
        stdde: e.target.dataset.stdde,
        mode: 'post'
      });
    }
  };

  const putItem = (e = null) => {
    setPopupReg({
      isVisible: true,
      stdde: e.target.dataset.stdde,
      mode: 'put'
    });
  };

  // 미리보기 팝업 state
  const [previewPopup, setPreviewPopup] = useState({isVisible: false, stdde: "0001-01-01"});

  const closePreviewPopup = () => {
    setPreviewPopup({isVisible: false, stdde: "0001-01-01"});
    setIsSearch(true);
    updateList();
  };

  const previewItem = (e = null) => {
    setPreviewPopup({
      isVisible: true,
      stdde: e.target.dataset.stdde,
    });
  };

  // 자료 다운로드(word)
  const downloadItem = (e = null) => {
    getSysReportWord(e.target.dataset.stdde)
        .then((res) => {
          if (res.data !== undefined) {
            const blob = new Blob([res.data], {type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'});
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = `[보고서-자료]-${e.target.dataset.stdde}.docx`;
            link.click();
          }
        })
        .catch((err) => {
          Swal.fire('다운로드 실패하였습니다.', '', 'error')
        });
  };

  // 운영일지 다운로드(word)
  const downloadOperationLog = (e = null) => {
    getSysOperationLogWord(e.target.dataset.stdde)
        .then((res) => {
          if (res.data !== undefined) {
            const blob = new Blob([res.data], {type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'});
            const link = document.createElement('a');
            console.log(blob)
            link.href = window.URL.createObjectURL(blob);
            link.download = `[보고서-운영일지]-${e.target.dataset.stdde}.docx`;
            link.click();
          }
        })
        .catch((err) => {
          Swal.fire('다운로드 실패하였습니다.', '', 'error')
        });
  }


  return (
      <>
        <PopUp
            propTitle={'운영일지 업로드'}
            propShow={previewPopup.isVisible}
            setShow={closePreviewPopup}
            propSize={'lg'}
        >
          <OperationLogUpload
              propStdde={previewPopup.stdde}
              hClose={closePreviewPopup}
          />
        </PopUp>

        <Row>
          <Col md={6} className={""}>
            <TableTopBar
                propSelectOption={{
                  isEnable: true,
                  selItems: [15, 30, 50], //미구현
                  setFunc: updatePageSize,
                }}
                propExcelDownload={{
                  isEnable: true,
                  getFunc: downloadExcelToTable,
                }}
                /*propPdfExport={{
                  isEnable: true,
                  // exportFilename: 'doc.pdf',
                  getFunc: exportReport,
                }}*/
                propPdf={{
                  isEnable: true,
                  getFunc: usePdf({
                    tableRef: tableRef,
                    setIsExport: setIsExport,
                    getAllList: getAllList,
                    updateList: updateList,
                    filename: '일일운영일지',
                  }),
                }}
                // propDelete={{
                //   isEnable: true,
                //   delFunc: delItem,
                // }}
                propReg={{
                  isEnable: false,
                  regFunc: regItem,
                }}
                // propControl = {{
                //     isEnable: true,
                //     ctlFunc: null,
                // }}
            />
          </Col>

          <Col md={12}>
            <div className={"table-responsive text-nowrap"}>
              <BootstrapTable hover className={"table text-center"} ref={tableRef}>
                <thead className={"table-head text-secondary"}>
                <tr className={"text-start"}>
                  <th className={""}>운영일지 기준일</th>
                  <th className={""}>자료 다운로드</th>
                  <th className={""}>운영일지 갱신일시</th>
                  <th className={""}>최종 작업자</th>
                  <th className={""}>운영일지 다운로드</th>
                  <th className={""}>운영일지 업로드</th>
                </tr>
                </thead>
                <tbody className={`table-body text-start ${isExport ? "" : "text-white"} `}>
                {
                  Array.isArray(tableList) ?
                      (tableList.map((elem, idx) => {
                        return (
                            <tr key={idx}>
                              <td>{elem.stdde_str}</td>
                              <td>
                                <Button type={"button"} variant="primary"
                                        onClick={downloadItem}
                                        data-stdde={elem.stdde_str}
                                >
                                  자료 다운로드
                                </Button>
                              </td>
                              <td>{elem.updt_dt_str}</td>
                              <td>{elem.userinfo}</td>
                              <td>
                                <Button type={"button"} variant="primary"
                                        disabled={elem.updt_yn !== 'Y'}
                                        onClick={downloadOperationLog}
                                        data-stdde={elem.stdde_str}
                                >
                                  운영일지 다운로드
                                </Button>
                              </td>
                              <td>
                                <Button type={"button"} variant="primary"
                                        onClick={previewItem}
                                        data-stdde={elem.stdde_str}
                                >
                                  운영일지 업로드
                                </Button>
                              </td>
                            </tr>
                        )
                            /*<tr key={idx}>
                          <td>{elem.stdde_str}</td>
                          <td>{elem.crt_dt_str}</td>
                          <td>{elem.userinfo}</td>
                          <td>
                            <Button
                                type={"button"}
                                onClick={putItem}
                                className={"btn reg-btn"}
                                data-stdde={elem.stdde_str}
                            >
                              수정
                            </Button>
                          </td>
                          <td>
                            <Button
                                type={"button"}
                                // onClick={handleOpenPopupDetail}
                                data-stdde={elem.stdde_str}
                                onClick={previewItem}
                                className={"btn reg-btn"}
                            >
                              미리보기
                            </Button>
                          </td>
                        </tr>*/;
                      })) :
                      ('')
                }
                </tbody>
              </BootstrapTable>
            </div>
          </Col>

          <Col className={"my-2"}>
            <Pagination
                propCurPage={currentPage}
                propTotal={total}
                propPageSize={listPageSize}
                propSetNewPage={setCurrentPage}
                propSetIsSearch={setIsSearch}
            />
          </Col>
        </Row>
      </>
  );
};

export default TableReport;
